import axios from "axios";
const uri = 'https://www.lefisc.com.br/api/apiCeclam/api/values/table';
const tok = 'ee183c55-18cd-4f5d-add7-1dc4e4e57527';

export default{
    getCodigos(texto){
        return axios
                .get(`${uri}/${texto}/${tok}`)
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    return err.response.data;
                })
    }
}


// WEBPACK FOOTER //
// ./src/services/serviceCeclam.js